var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 35,
    viewBox: "0 0 240 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07058 0.195762H20.3L17.6745 11.7476H23.0274L25.755 0H38.8844L31.2078 33.9694H18.1784L21.1078 20.9502H15.6549L12.8275 34.0682H0L7.07058 0.195762Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3726 0L91.502 0.195762L86.453 22.7122C86.453 22.7122 85.4432 26.6274 88.3726 26.6274C91.302 26.6274 91.7058 23.8868 92.2098 21.8302C92.7156 19.7738 96.8548 0.0969304 96.8548 0.0969304H109.884L104.531 23.7878C104.531 23.7878 102.916 35.7312 87.5646 34.9482C87.5646 34.9482 71.6078 36.2216 73.4254 23.3964L78.3726 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.53 0H127.659L122.004 25.5516L135.336 25.6486L132.406 34.1652H107.055L114.53 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.98 0.195662H144.023L136.448 34.1651H149.072L151.799 22.4175L159.98 22.2217C172.199 21.0471 172.099 10.9644 172.099 10.9644C173.007 0.195662 159.98 0.195662 159.98 0.195662ZM159.374 11.356C158.262 16.0542 153.315 14.4882 153.315 14.4882L154.831 7.73343C160.486 6.95039 159.376 11.356 159.376 11.356H159.374Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7207 34.0189L68.5089 0.146484H50.5325L34.7775 34.0189H47.9069L50.0285 28.5375H57.3011L56.8971 34.0189H69.7245H69.7207ZM53.6619 19.5307L53.6795 19.4813H53.4265L57.7697 6.95062L57.7423 7.75268L58.0049 6.99814L57.6011 19.5288H53.6619V19.5307Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.758 34.0356L200.546 0.163225H182.57L166.815 34.0356H179.944L182.066 28.5544H189.338L188.935 34.0356H201.762H201.758ZM185.699 19.5474L185.717 19.498H185.464L189.807 6.96737L189.78 7.76941L190.042 7.01487L189.638 19.5455H185.699V19.5474Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.314 0.0983543H217.712L219.396 13.0205L226.602 0.162975H240L223.436 22.6128L220.81 34.2312H207.95L210.778 21.5694L204.314 0.0983543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterLogo);
export default __webpack_public_path__ + "static/media/letter-logo.4c4ffb768a02727f329d4edcf38ab367.svg";
export { ForwardRef as ReactComponent };